"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationModesDefault = exports.applicationMode = exports.ApplicationModes = void 0;
const typegate_1 = require("typegate");
exports.ApplicationModes = {
    digital: 'digital',
    paper: 'paper',
};
exports.applicationMode = typegate_1.t.union(typegate_1.t.literal('digital'), typegate_1.t.literal('paper'));
exports.ApplicationModesDefault = [exports.ApplicationModes.digital, exports.ApplicationModes.paper];
